import { ReactNode } from 'react';
import logo from '../../../assets/images/ryd-logo.png';

interface Props {
    children: ReactNode;
}

export default function AuthLayout({ children }: Props) {
    return (
        <div className="relative flex min-h-[100dvh] items-center justify-center overflow-x-hidden bg-[#FBF8FC] px-3 py-6 sm:px-6 sm:py-8">
            {/* Soft decorative blobs */}
            <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#E8C4DE]/50 blur-3xl" />
            <div className="pointer-events-none absolute -right-20 top-1/4 h-80 w-80 rounded-full bg-[#D4C4F0]/45 blur-3xl" />
            <div className="pointer-events-none absolute bottom-0 left-1/3 h-64 w-64 rounded-full bg-[#F5C4D8]/35 blur-3xl" />

            <div className="relative z-10 w-full max-w-[560px]">
                <div className="rounded-[20px] border border-white/80 bg-white px-4 py-6 shadow-[0_20px_60px_rgba(136,22,122,0.08)] sm:rounded-[28px] sm:px-10 sm:py-9">
                    <img
                        src={logo}
                        alt="RYD Learning"
                        className="mx-auto mb-5 h-[32px] w-auto object-contain sm:mb-6 sm:h-[36px]"
                    />
                    {children}
                </div>
            </div>
        </div>
    );
}
